import { REPORTS_FINANCIAL_REQUEST, REPORTS_FINANCIAL, REPORTS_FINANCIAL_CLEAR, REPORTS_FINANCIAL_FAIL,
	REPORTS_FINANCIAL_EDIT_REQUEST, REPORTS_FINANCIAL_GOAL, REPORTS_FINANCIAL_ACTIVITY, REPORTS_FINANCIAL_EDIT_FAIL,
	REPORTS_PERSONS_EDIT_REQUEST,
	/*REPORTS_FINANCIAL_EDIT_INVOICE_FAIL, */REPORTS_EXPENSES, REPORTS_EXPENSES_REQUEST, REPORTS_EXPENSES_CLEAR,
	REPORTS_EXPENSES_FAIL, REPORTS_EXPENSES_EDIT, REPORTS_EXPENSES_EDIT_REQUEST, REPORTS_EXPENSES_EDIT_FAIL,
	REPORTS_EMPLOYEES, REPORTS_EMPLOYEES_EDIT, REPORTS_EMPLOYEES_EDIT_REQUEST, REPORTS_EMPLOYEES_EDIT_FAIL,
	REPORTS_EMPLOYEES_REQUEST, REPORTS_EMPLOYEES_CLEAR, REPORTS_EMPLOYEES_FAIL, REPORTS_SUMMARY, REPORTS_SUMMARY_REQUEST,
	REPORTS_SUMMARY_CLEAR, REPORTS_SUMMARY_FAIL, REPORTS_SUMMARY_COMPLETE, REPORTS_SURVEYS, REPORTS_SURVEYS_REQUEST,
	REPORTS_SURVEYS_CLEAR, REPORTS_SURVEYS_FAIL/*, REPORTS_SURVEYS_COMPLETE */} from "../store/config";
const reportsInit = {
	isFetching: false,
	project_name: undefined,
	activity_persons:{
		isFetching: false,
		data: {},
		edit: {
			isFetching: false,
			action: undefined
		},
		revision: {}
	},
	financial:{
		isFetching: false,
		data: {},
		edit: {
			isFetching: false,
			action: undefined
		},
		revision: {}
	},
	expenses:{
		isFetching: false,
		data: {},
		edit: {
			isFetching: false,
		action: undefined
		},
		agency: [],
		revision: {}
	},
	employees:{
		isFetching: false,
		data: {},
		edit: {
			isFetching: false,
			action: undefined
		},
		revision: {}
	},
	surveys: {
		isFetching: false,
		data: {}
	},
	summary:{
		isFetching: false,
		data: {},
		edit: {},
		revision: {}
	},
	phase_group:{},
	version:{},
	permissions:[],
	error: undefined,
	timestamp: undefined
}

const reports = (state = reportsInit, action) => {
	switch(action.type){
		case REPORTS_FINANCIAL_REQUEST:
			return{
				...state,
				financial:{
					...state.financial,
					isFetching: action.isFetching,
				},
				timestamp: action.timestamp
			}
		case REPORTS_FINANCIAL:
			return{
				...state,
				project_name: action.payload.name,
				financial:{
					...state.financial,
					isFetching: action.isFetching,
					data: action.payload,
					revision: action.revision,
				},
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_FINANCIAL_EDIT_REQUEST:
			return{
				...state,
				financial:{
					...state.financial,
					edit: {
						...state.financial.edit,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case REPORTS_FINANCIAL_GOAL:
			return{
				...state,
				project_name: action.payload.name,
				financial:{
					...state.financial,
					data: action.payload,
					edit:{
						...state.financial.edit,
						...action.edit,
						isFetching: action.isFetching
					}
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_FINANCIAL_ACTIVITY:
			return{
				...state,
				project_name: action.payload.name,
				financial:{
					...state.financial,
					data: action.payload,
					edit:{
						...state.financial.edit,
						...action.edit,
						isFetching: action.isFetching
					}
				},
				activity_persons:{
					...state.activity_persons,
					edit: {
						...state.activity_persons.edit,
						isFetching: action.isFetching,
					}
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_FINANCIAL_EDIT_FAIL:
			return{
				...state,
				financial:{
					...state.financial,
					edit: {
						...state.financial.edit,
						isFetching: action.isFetching,
					}
				},
				activity_persons:{
					...state.activity_persons,
					edit: {
						...state.activity_persons.edit,
						isFetching: action.isFetching,
					}
				},
				error: action.error,
				timestamp: action.timestamp
			}
		/*case REPORTS_FINANCIAL_EDIT_INVOICE_FAIL:
			return{
				...state,
				financial:{
					...state.financial,
					edit: {
						...state.financial.edit,
						xmlForm: action.show
					}
				},
				timestamp: action.timestamp
			}*/
		case REPORTS_FINANCIAL_CLEAR:
			return{
				...state,
				financial:{
					...state.financial,
					data: action.payload,
					edit: action.payload
				},
				timestamp: action.timestamp
			}
		case REPORTS_FINANCIAL_FAIL:
			return{
				...state,
				financial:{
					...state.financial,
					isFetching: action.isFetching
				},
				error: action.error,
				timestamp: action.timestamp
			}

		case REPORTS_PERSONS_EDIT_REQUEST:
			return{
				...state,
				activity_persons:{
					...state.activity_persons,
					edit: {
						...state.activity_persons.edit,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case REPORTS_EXPENSES_REQUEST:
			return{
				...state,
				expenses:{
					...state.expenses,
					isFetching: action.isFetching,
				},
				timestamp: action.timestamp
			}
		case REPORTS_EXPENSES:
			return{
				...state,
				project_name: action.payload.name,
				expenses:{
					...state.expenses,
					isFetching: action.isFetching,
					data: action.payload,
					revision: action.revision,
				},
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_EXPENSES_CLEAR:
			return{
				...state,
				expenses:{
					...state.expenses,
					data: action.payload,
					edit: action.payload
				},
				timestamp: action.timestamp
			}
		case REPORTS_EXPENSES_FAIL:
			return{
				...state,
				expenses:{
					...state.expenses,
					isFetching: action.isFetching
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case REPORTS_EXPENSES_EDIT_REQUEST:
			return{
				...state,
				expenses:{
					...state.expenses,
					edit:{
						...state.expenses.edit,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case REPORTS_EXPENSES_EDIT:
			return{
				...state,
				project_name: action.payload.name,
				expenses:{
					...state.expenses,
					data: action.payload,
					edit: {
						...state.expenses.edit,
						...action.edit,
						isFetching: action.isFetching
					}
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_EXPENSES_EDIT_FAIL:
			return{
				...state,
				expenses:{
					...state.expenses,
					edit: {
						...state.expenses.edit,
						isFetching: action.isFetching,
					}
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case REPORTS_EMPLOYEES_REQUEST:
			return{
				...state,
				employees:{
					...state.employees,
					isFetching: action.isFetching,
				},
				timestamp: action.timestamp
			}
		case REPORTS_EMPLOYEES:
			return{
				...state,
				project_name: action.payload.name,
				employees:{
					...state.employees,
					isFetching: action.isFetching,
					data: action.payload,
					revision: action.revision,
				},
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_EMPLOYEES_CLEAR:
			return{
				...state,
				employees:{
					...state.employees,
					data: action.payload,
					edit: action.payload
				},
				timestamp: action.timestamp
			}
		case REPORTS_EMPLOYEES_FAIL:
			return{
				...state,
				employees:{
					...state.employees,
					isFetching: action.isFetching
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case REPORTS_EMPLOYEES_EDIT_REQUEST:
			return{
				...state,
				employees:{
					...state.employees,
					edit:{
						...state.employees.edit,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case REPORTS_EMPLOYEES_EDIT:
			return{
				...state,
				project_name: action.payload.name,
				employees:{
					...state.employees,
					data: action.payload,
					edit: {
						...state.employees.edit,
						...action.edit,
						isFetching: action.isFetching
					}
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_EMPLOYEES_EDIT_FAIL:
			return{
				...state,
				employees:{
					...state.employees,
					edit: {
						...state.employees.edit,
						isFetching: action.isFetching,
					}
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case REPORTS_SUMMARY_REQUEST:
			return{
				...state,
				summary:{
					...state.summary,
					isFetching: action.isFetching,
				},
				timestamp: action.timestamp
			}
		case REPORTS_SUMMARY_COMPLETE:
			return{
				...state,
				summary:{
					...state.summary,
					isFetching: action.isFetching,
				},
				timestamp: action.timestamp
			}
		case REPORTS_SUMMARY:
			return{
				...state,
				project_name: action.payload.name,
				summary:{
					...state.summary,
					isFetching: action.isFetching,
					data: action.payload,
					edit:{
						...state.summary.edit,
						...action.edit
					},
					revision: action.revision
				},
				phase_group: action.phase_group,
				permissions: action.permissions,
				version: action.version,
				timestamp: action.timestamp
			}
		case REPORTS_SUMMARY_CLEAR:
			return{
				...state,
				summary:{
					...state.summary,
					data: action.payload,
					edit: action.payload,
					revision: action.payload
				},
				timestamp: action.timestamp
			}
		case REPORTS_SUMMARY_FAIL:
			return{
				...state,
				summary:{
					...state.summary,
					isFetching: action.isFetching
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case REPORTS_SURVEYS_REQUEST:
			return{
				...state,
				surveys:{
					...state.surveys,
					isFetching: action.isFetching,
				},
				timestamp: action.timestamp
			}
		case REPORTS_SURVEYS:
			return{
				...state,
				surveys:{
					...state.surveys,
					isFetching: action.isFetching,
					data: action.payload
				},
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case REPORTS_SURVEYS_CLEAR:
			return{
				...state,
				surveys:{
					...state.surveys,
					data: action.payload
				},
				timestamp: action.timestamp
			}
		case REPORTS_SURVEYS_FAIL:
			return{
				...state,
				surveys:{
					...state.surveys,
					isFetching: action.isFetching
				},
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default reports;


// WEBPACK FOOTER //
// ./src/reducers/reports.js